import { Component,ElementRef, AfterViewInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'main-component',
  templateUrl: './common.tpl.html'
})
export class CommonComponent implements AfterViewInit {
 	private industries:any[];
  	constructor(){
  		this.industries = [{
		"name":"Water and Waste Water",
		"title":"Water and Waste Water",
		"url":"water.jpg"
		},
		{
		"name":"Oil and Gas",
		"title":"Oil and Gas",
		"url":"oil.jpg"
		},{
		"name":"Iron & Steel",
		"title":"Iron & Steel",
		"url":"iron.jpg"
		},
		{
		"name":"Power & Cement",
		"title":"Power & Cement",
		"url":"power.jpg"
		},{
		"name":"Pharmacy",
		"title":"Pharmacy",
		"url":"pharmacy.jpg"
		},{
		"name":"Food & Beverages",
		"title":"Food & Beverages",
		"url":"box.jpg"
		},{
		"name":"Chemical & Fertilizer",
		"title":"Chemical & Fertilizer",
		"url":"chemical.jpg"
		},{
		"name":"Pulp & Paper",
		"title":"Pulp & Paper",
		"url":"roll.jpg"
		}];
  	}
  ngAfterViewInit() {
    $('#slides').superslides({
		//animation: "fade",
		play: 5000,
		slide_speed: 800,
		pagination: true,
		hashchange: false,
		scrollable: true,
		
	});
  }
}



// WEBPACK FOOTER //
// ./src/app/common/common.component.ts